module.exports = __webpack_public_path__ + "img/facebook-icon-footer.5b3ff213.svg";